var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { KeycloakService } from './keycloak.service';
import { SharedService } from './shared.service';
var HttpClientWrapper = (function () {
    function HttpClientWrapper(http) {
        this.http = http;
    }
    HttpClientWrapper.prototype.createAuthorizationHeader = function (headers) {
        headers.append('Authorization', 'Basic ' + btoa(SharedService.unescape(encodeURIComponent('username:password'))));
    };
    HttpClientWrapper.prototype.getHeaders = function (options) {
        if (!options) {
            options = {
                headers: KeycloakService.getBearer().headers
            };
        }
        else {
            options["headers"] = KeycloakService.getBearer().headers;
        }
        return options;
    };
    HttpClientWrapper.prototype.get = function (url, options) {
        options = options || {};
        options.withCredentials = true;
        return this.http.get(url, this.getHeaders(options));
    };
    HttpClientWrapper.prototype.delete = function (url, options) {
        options = options || {};
        options.withCredentials = true;
        return this.http.delete(url, this.getHeaders(options));
    };
    HttpClientWrapper.prototype.put = function (url, options) {
        options = options || {};
        options.withCredentials = true;
        return this.http.put(url, this.getHeaders(options));
    };
    HttpClientWrapper.prototype.post = function (url, data, options) {
        options = options || {};
        options.withCredentials = true;
        return this.http.post(url, data, this.getHeaders(options));
    };
    HttpClientWrapper.prototype.getPublic = function (url, options) {
        return this.http.get(url, options);
    };
    return HttpClientWrapper;
}());
HttpClientWrapper = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [Http])
], HttpClientWrapper);
export { HttpClientWrapper };
//# sourceMappingURL=httpClient.js.map